// extracted by mini-css-extract-plugin
export var dividerContainer = "_8z-0";
export var line = "_8z-1";